export default {
  props: ['menuItems', 'newsCount', 'coursesCount'],
  components: {
  },
  computed: {
    user() { return this.$store.state.user; },
    userAvatar() {
      return this.$store.state.user.full_name.split(' ').map(x => x[0]).join('');
    },
    sidebar() { return this.$store.state.app.sidebar; },
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
    isBlocked() { return !!(this.$store.getters.isBlocked); },
    onModeration() { return !!(this.$store.getters.onModeration); },
    isApproved() { return !!(this.$store.getters.isApproved); },
    extranet() { return this.$store.state.settings.extranet === true; },
    logoUrl() { return this.$store.state.settings.logoUrl; },
    newMobileNotifications() { return this.$store.state.mobileNotifications.notificationsNew; },
    epsCartLength() { return this.$store.state.eps.cartLength; },
    epsCartSummary() { return this.$store.state.eps.cartSummary; },
    productsCartLength() { return this.$store.state.shop.cart.cartLength; },
    isRus() { return this.$store.getters.isRus; },
    isBy() { return this.$store.getters.isBy; },
    isKz() { return this.$store.getters.isKz; },
  },
  methods: {
    SetSidebar(status) {
      this.$store.dispatch('app/SetSidebar', status);
    },
    UserLogout() {
      this.$store.dispatch('UserLogout');
      this.$router.push('/');
    },
    GetSubWithCurrency(bonus) {
      if (this.user.currency_rate && this.user.currency_rate.payments_rate) {
        return `${Math.round(bonus / this.user.currency_rate.payments_rate)} ${this.isBy ? 'BYN' : 'KZT'}`;
      }
      return '';
    },
  },
  created() {
    this.user && this.$store.dispatch('mobileNotifications/GetNotifications', this.user.profile_id);
  },
};
